import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-usecase-help',
  templateUrl: './usecase-help.component.html',
  styleUrls: ['./usecase-help.component.css']
})
export class UsecaseHelpComponent extends BaseListCtl {
  @Input() appId: number = 0;
  @Input() usecaseId: number | null = 0;
  @Input() uiformId: number | null = 0; // pass as a input 
  @Input() id: number | null = 0;


  public usecaseSchema: any = {
  };

  public attributeId: number = 0;

  public entryform: any = {
    data: { id: 0 }, //form data
  };

  constructor(public override locator: ServiceLocatorService, public override route: ActivatedRoute) {
    super("", locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('appId'))
      _self.appId = Number(route.snapshot.paramMap.get('appId'));

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));

    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));

    if (route.snapshot.paramMap.get('id'))
      _self.id = Number(route.snapshot.paramMap.get('id'));

    _self.locator.config
    .getProperty('endpoint.ui.forms')
    .then((property: string) => {
      _self.initApiEndpoint(property);
    });

  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.title = data.title;
    form.subtitle = data.subtitle;
    form.description = data.description;
    form.userstoryId = data.userstoryId;
    form.code = data.code;
    form.description = data.description;
    form.columns = data.columns;
    form.fields = data.fields;
    form.readOnly = data.readOnly;
    if (data.buttons) {
      form.buttons = data.buttons;
    }

    if (data.inputs) {
      form.inputs = data.inputs;
    }
  }
  override ngOnInit() {
    let _self = this;
    if (_self.uiformId)
      this.get(_self.uiformId, function () {
        _self.usecaseId = _self.form.data.userstoryId;       
        console.log(_self.form);
        _self.getUsecaseSchema();
      })

  }

  public attributeList: any = [];
  public getUsecaseSchema() {
    let _self = this;
    let url = _self.locator.config.get("endpoint.userstory") + "/get/" + _self.usecaseId;
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert("Server Error:" + error);
        return;
      }
      _self.usecaseSchema = res.result.data;
      _self.attributeId = _self.usecaseSchema['appId']
      console.log("usecaseSchema", _self.usecaseSchema);
      _self.getUsecasePreloadData();

      // if (_self.id) {
      //   _self.getUiformData(_self.id)
      // }

    });
    let attrUrl = _self.locator.config.get("endpoint.userstory.attributes") + "/list/" + _self.usecaseId;
    //{ userstoryId: _self.usecaseId },
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      _self.attributeList = res.result.data;
    });

  }


 /**
  * Get usecase preload data
  */
 public getUsecasePreloadData() {
  let _self = this;
  let url = _self.getAPIBaseUrl("preload");
  //let url = _self.locator.endpoints.CD_DATA + "/" + _self.usecaseName + "/preload";
  this.locator.http.get(url, function (res: any, error: boolean) {
    if (error) {
      alert("Server Error:" + error);
      return;
    }
    _self.form["preload"] = res.result;
});
}
  /**
   * Get API base URL
   * @returns 
   */
  getAPIBaseUrl(suburl?: string) {
    let _self = this;
    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');
    let url = _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
    if (suburl) {
      url += '/' + suburl;
    }
    return url;
  }

  getAttributeById(fieldId: number) {
    return this.attributeList.find((attr: any) => attr.id === fieldId && attr['system'] != 1);
  }
}
